<template>
    <div class="throughDataMainBox">
        <div class="complaintNumberBox">
            <div class="complaintNumberTitle">投诉单号</div>
            <div class="complaintNumber">{{itemList.mainComplainNumber}}</div>
        </div>
        <div class="synchronizationBox">
            <div class="synchronizationTitle">是否同步给游客</div>
            <van-RadioGroup class="radioBox" v-model="synchronization">
                <van-Radio name='2' checked-color="#07c160">否</van-radio>
                <van-Radio name='1' checked-color="#07c160">是</van-radio>
            </van-RadioGroup>
        </div>
        <div class="supplementBox">
            <div class="supplementTitle">补充内容</div>
            <div class="supplementTextBox">
                <van-field
                    class="supplementText"
                    v-model="msg"
                    rows="5"
                    autosize
                    type="textarea"
                    maxlength="500"
                    placeholder="请输入补充内容"
                    show-word-limit
                />
            </div>
        </div>
        <div class="uploadBox">
               <upload :imgUrl="imgUrl"></upload>
        </div>
        <div class="btnBox">
            <div class="submitBtn" @click="handleSubmit">提交</div>
            <div class="keepBtn" @click="saveSupplement">保存</div>
        </div>
    </div>
</template>

<script>
    import api from '../../../../service/modules/complaintApis'
    import util from '@/utils/common'
    import upload from '@/components/uploadCopy'
    export default {
        components: {
            upload
        },
        data () {
            return {
                synchronization: '2',
                msg: '',
                fileList: [],
                itemList: util.getJsonLocal('item'),
                isback: this.$store.state.complaint.isBackDetail || util.getJsonLocal('isBack'),
                imgUrl: [], // 上传的图片
                saveId: '' // 保存id
            }
        },
        created () {
            this.getSupplementDetail();
        },
        mounted () {
            this.$on('fileUploadData', val => {
                this.imgUrl = val
            })
        },
        methods: {
            afterRead (file) {
                // 此时可以自行将文件上传至服务器
                console.log(file);
            },
            // 保存
            saveSupplement () {
                const params = {
                    mainComplainNumber: this.itemList.mainComplainNumber,
                    complainNumber: this.itemList.complainNumber,
                    subId: this.itemList.subId,
                    supplementContent: this.msg,
                    synchronization: this.synchronization,
                    id: this.saveId,
                    product:'',
                    imageUrl: this.imgUrl
                }
                if (this.msg.trim().length === 0) {
                    this.$Toast('请输入补充内容');
                } else {
                    api.worker.saveSupplementContent(params).then(res => {
                        if (res.ret === 0) {
                            this.$Toast('操作成功');
                            this.$router.back();
                        }
                    })
                }
            },
            // 提交
            handleSubmit () {
                if (this.msg.trim().length === 0) {
                    this.$Toast('请输入补充内容');
                } else {
                    const params = {
                        // data:{
                        //     mainComplainNumber: this.itemList.mainComplainNumber,
                        //     complainNumber: this.itemList.complainNumber,
                        //     subId: this.itemList.subId,
                        //     supplementContent: this.msg,
                        //     synchronization: this.synchronization,
                        //     id: this.saveId,
                        //     imageUrl: this.imgUrl,
                        //     // product:''
                        // }
                            mainComplainNumber: this.itemList.mainComplainNumber,
                            complainNumber: this.itemList.complainNumber,
                            subId: this.itemList.subId,
                            supplementContent: this.msg,
                            synchronization: this.synchronization,
                            id: this.itemList.id,
                            imageUrl: this.imgUrl,
                            product:0
                    }
                    api.worker.supplementMaterials(params).then(res => {
                        console.log(res);
                        if (res.ret === 0) {
                            this.$Toast('操作成功');
                            this.$router.back();
                        }
                    })
                }
            },
            // 初始化保存的补充内容
            getSupplementDetail () {
                const data = {
                    mainComplainNumber: this.itemList.mainComplainNumber,
                    complainNumber: this.itemList.complainNumber
                }
                api.worker.supplementDetail(data).then(res => {
                    this.msg = res.data.supplementContent;
                    this.synchronization = res.data.synchronization.toString();
                    this.imgUrl = res.data.imageUrl;
                    this.saveId = res.data.id;
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .throughDataMainBox{
        background-color: #FBFBFB;
        .uploadBox{
            padding: 20px 18px;
        }
        .complaintNumberBox::after{
            content: '';
            display: block;
            clear: both;
        }

        .complaintNumberBox{
            padding: 0 16px;
            font-size: 14px;
            line-height: 40px;
            border-bottom: 1px solid #eee;

            .complaintNumberTitle{
                width: 110px;
                color: #999;
                float: left;
            }

            .complaintNumber{
                margin-left: 110px;
                text-align: right;
            }
        }

        .synchronizationBox::after{
            content: '';
            display: block;
            clear: both;
        }

        .synchronizationBox{
            padding: 0 16px;
            font-size: 14px;
            line-height: 40px;
            border-bottom: 1px solid #eee;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .synchronizationTitle{
                width: 110px;
                color: #999;
                float: left;
            }

            .radioBox{

                .van-radio:first-child{
                    margin-left: 20px;
                }

                .van-radio{
                    float: right;

                    .van-radio__label{
                        line-height: 40px;
                    }
                }

            }
        }

        .supplementBox{
            padding: 0 16px;
            font-size: 14px;
            line-height: 40px;
            border-bottom: 1px solid #eee;

            .supplementTitle{
                color: #999;
            }

            .supplementTextBox{
                padding-bottom: 20px;
                .supplementText{
                   background-color: #eee;
                   border-radius: 3px;
                }
            }

        }

        .upLoaderBox{
            padding: 0 16px 30px;
            font-size: 14px;
            line-height: 40px;

            .upLoaderTitle{
                margin: 0 0 30px 0;
                color: #999
            }

            .upLoaderMainBox{
                height: 100px;
            }
        }

        .btnBox{
            padding: 0 16px;

            >div{
                height: 36px;
                font-size: 14px;
                text-align: center;
                line-height: 36px;
                border-radius: 3px;
            }

            .submitBtn{
                margin-bottom: 12px;
                color: #fff;
                background-color: #36B374;
            }

            .keepBtn{
                color: #666;
                background-color: #eee;
            }
        }
    }
</style>
